<template>
  <section class="section reviews-section">
    <div class="wrap review-layout">
      <div>
        <h2>Happy Clients</h2>
        <div class="review-index" aria-hidden="true">
          <span v-for="(_, i) in reviews" :key="i" :class="{ active: i === index }" />
        </div>
      </div>
      <div class="review-quote">
        <blockquote aria-live="polite">«{{ reviews[index].text }}»</blockquote>
        <div class="review-footer">
          <span class="review-author"
            >{{ reviews[index].name }} <span class="gallery-count">· Google-Bewertung</span></span
          >
          <div class="review-controls">
            <button
              class="icon-button"
              aria-label="Vorherige Bewertung"
              @click="index = (index - 1 + reviews.length) % reviews.length"
            >
              <InkIcon name="back" /></button
            ><button
              class="icon-button"
              aria-label="Nächste Bewertung"
              @click="index = (index + 1) % reviews.length"
            >
              <InkIcon name="arrow" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup>
import { ref } from 'vue';
import InkIcon from './InkIcon.vue';
const index = ref(0);
const reviews = [
  {
    text: 'Rebecca ist eine sehr talentierte Tätowiererin. Sie nimmt sich viel Zeit für jedes Projekt und geht mit ihrer ruhigen und sympathischen Art vollständig auf die individuellen Wünsche ein.',
    name: 'Dominique R.',
  },
  {
    text: 'Für mich die beste Tätowiererin, so kreative und wunderschöne Tattoo Designs! Und so präzise und fein gestochen. Ich kann sie wärmsten empfehlen!',
    name: 'Franziska P.',
  },
  {
    text: 'Bin mit dem Ergebnis, aber auch der Beratung und dem Ablauf sehr zufrieden. Der Kontakt war stets freundlich und auch das Studio gefiel mir gut.',
    name: 'Elena S.',
  },
  {
    text: 'Das Studio kann ich bestens empfehlen. Rebecca ist eine Künsterin und bringt die Bilder, bis ins kleinste Detail, sagenhaft auf die Haut.',
    name: 'Birgit A.',
  },
  {
    text: 'Hab mir bisher ein Tattoo hier stechen lassen und kann es definitiv weiterempfehlen. Sympathisch und professionell 👌🏼',
    name: 'Nesim P.',
  },
];
</script>
